import type { Flag } from '@eppo/js-client-sdk-common'
import { logger } from '@moonpig/web-core-monitoring'

export const EPPO_CUSTOMER_ENTITY_ID = 844

export type EppoFlagConfiguration = Pick<Flag, 'key' | 'entityId'>

const resolveEppoSubjectKeyInternal = (
  flagConfiguration: EppoFlagConfiguration,
  sessionId: string,
  customerId: string | null,
  logWhenUnavailable: boolean,
): string | null => {
  const flagKey = flagConfiguration.key

  if (flagConfiguration.entityId === EPPO_CUSTOMER_ENTITY_ID) {
    if (!customerId) {
      if (logWhenUnavailable) {
        logger.info(
          `Eppo subject key unavailable | flag=${flagKey} | reason=missing_customer`,
        )
      }
      return null
    }
    return customerId
  }

  if (!sessionId) {
    if (logWhenUnavailable) {
      logger.info(
        `Eppo subject key unavailable | flag=${flagKey} | reason=missing_session`,
      )
    }
    return null
  }

  return sessionId
}

/** Resolves the Eppo subject key and logs when it cannot be resolved (e.g. missing customer for a customer-scoped flag). */
export const resolveEppoSubjectKey = (
  flagConfiguration: EppoFlagConfiguration,
  sessionId: string,
  customerId: string | null,
): string | null =>
  resolveEppoSubjectKeyInternal(flagConfiguration, sessionId, customerId, true)

/**
 * Resolves the Eppo subject key without logging when unavailable.
 * Use when enumerating flags where skipping customer-scoped experiments before login is expected.
 */
export const tryResolveEppoSubjectKey = (
  flagConfiguration: EppoFlagConfiguration,
  sessionId: string,
  customerId: string | null,
): string | null =>
  resolveEppoSubjectKeyInternal(flagConfiguration, sessionId, customerId, false)
